module.exports = __webpack_public_path__ + "img/customer-lyalty-depth.a0bda956.png";